// Simple browser-compatible logger
class Logger {
  private prefix = '[FlexHelp]';

  info(...args: any[]) {
    console.info(this.prefix, ...args);
  }

  error(...args: any[]) {
    console.error(this.prefix, ...args);
  }

  warn(...args: any[]) {
    console.warn(this.prefix, ...args);
  }

  debug(...args: any[]) {
    if (process.env.NODE_ENV !== 'production') {
      console.debug(this.prefix, ...args);
    }
  }

  // Add error tracking/reporting in production
  track(error: Error, context?: Record<string, any>) {
    if (process.env.NODE_ENV === 'production') {
      // Here you would typically send to an error tracking service
      console.error(this.prefix, 'Error:', error, 'Context:', context);
    }
  }
}

export const logger = new Logger();